import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Avatar from "@mui/material/Avatar";
import { DialogContent } from "@mui/material";
import IconView from "../../Contents/FontIcons/IconView";
import Verification from "../Verification";
import ApprovalLoan from "../ApprovalLoan";
import Bankreviewer from "../Bankreviewer";


export default function BankStatusListDialogue(props) {

  const [open, setOpen] = React.useState(false);
  const {type,Bgcolor,name} = props;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false); 
  };



  // Get List of Qualification from the server

  React.useEffect(() => {
   
  }, []);
 
  return (
    <div className="appicant-profile-dialog-con w-500rem ">
      <Button sx={{backgroundColor:Bgcolor, marginRight:"1em"}} variant="contained" onClick={handleClickOpen}>
         <span>{type} Applications</span>
        <IconView
          tooltipText="View Applicants Profile"
          tooltipColor="white"
          tooltipIconSize="19px"
         />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth=""
      >
        <DialogContent>
       

              <Bankreviewer params={type === "Ready For DISBURSEMENT" ? "readydisburs" : type === "DISBURSEMENT DONE" ? "disbursedone" : type} name={name} type="BankStatusListDialogue" />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
